import axios from 'axios';

import { BASE_URL } from '@constants';

export const cancelToken = axios.CancelToken.source;

// Language code mapping (inline to avoid circular dependency)
const LANGUAGE_CODE_MAP: Record<string, string> = {
  br: 'pt-BR',
  en: 'en-US',
  es: 'es-ES',
  pt: 'pt-BR',
  'pt-BR': 'pt-BR',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
};

const mapToApiCode = (code: string): string => LANGUAGE_CODE_MAP[code] || code;

export const api = axios.create({
  baseURL: BASE_URL,
});

// Add interceptor to set language headers
api.interceptors.request.use((config) => {
  // Get current language from localStorage (set by i18next)
  const currentLang = localStorage.getItem('i18nextLng') || 'br';
  // Map legacy code to API code
  const apiLangCode = mapToApiCode(currentLang);
  // Set both headers for maximum compatibility
  // eslint-disable-next-line no-param-reassign
  config.headers['Accept-Language'] = apiLangCode;
  // eslint-disable-next-line no-param-reassign
  config.headers['X-localization'] = currentLang;
  return config;
});

export const chatApi = axios.create({
  baseURL: process.env.REACT_APP_CHAT_BASE_URL,
});
